export const SIRUC_RECORDS = {
  newButton: 'siruc-record-new-button',
  list: 'siruc-record-list',
  row: 'siruc-record-row',
  detailBack: 'siruc-record-detail-back',
  detailExitButton: 'siruc-record-detail-exit-button',
  detailAddInspection: 'siruc-record-detail-add-inspection',
  formPlacas: 'siruc-record-form-placas',
  formChofer: 'siruc-record-form-chofer',
  formLicencia: 'siruc-record-form-licencia',
  formCompania: 'siruc-record-form-compania',
  formTipoUnidad: 'siruc-record-form-tipo-unidad',
  formDestino: 'siruc-record-form-destino',
  formSelloEntrada: 'siruc-record-form-sello-entrada',
  formDescripcion: 'siruc-record-form-descripcion',
  formGuardia: 'siruc-record-form-guardia',
  formSubmit: 'siruc-record-form-submit',
  exitCortina: 'siruc-exit-cortina',
  exitSello: 'siruc-exit-sello',
  exitCondicion: 'siruc-exit-condicion',
  exitDestino: 'siruc-exit-destino',
  exitGuardia: 'siruc-exit-guardia',
  exitSubmit: 'siruc-exit-submit',
};

export const SIRUC_INSPECTIONS = {
  newButton: 'siruc-inspection-new-button',
  list: 'siruc-inspection-list',
  row: 'siruc-inspection-row',
  approveButton: 'siruc-inspection-approve-button',
  formType: 'siruc-inspection-form-type',
  formPlacas: 'siruc-inspection-form-placas',
  formTrailer: 'siruc-inspection-form-trailer',
  formPrecinto: 'siruc-inspection-form-precinto',
  formSelloAlta: 'siruc-inspection-form-sello-alta',
  formSelloVerificado: 'siruc-inspection-form-sello-verificado',
  formInspector: 'siruc-inspection-form-inspector',
  formCompania: 'siruc-inspection-form-compania',
  formActividad: 'siruc-inspection-form-actividad',
  pointEstado: 'siruc-inspection-point-estado',
  pointComentarios: 'siruc-inspection-point-comentarios',
  formSubmit: 'siruc-inspection-form-submit',
};
